import { get as getWidget } from "Components/Device/Flow/constants";
import { useDevice } from "Hooks/Endpoints";
import React, { Fragment } from "react";
import {
  Button,
  Container,
  Header,
  Icon,
  Label,
  Message,
  Table,
} from "semantic-ui-react";
import { set, get } from "lodash";
import { Device } from "callable-data-objects";

type ConnectToProps = {
  type: string;
  field?: string;
};
const ConnectTo = ({ type, field = "connectTo" }: ConnectToProps) => {
  const { devices, device, update, select } = useDevice();

  async function disconnect() {
    if (device) {
      set(device, `${type}.${field}`, "HANGUP");
      update(device);
    }
  }

  async function connect(newDevice: Device) {
    if (device) {
      const { id } = newDevice;
      set(device, `${type}.${field}`, id);
      update(device);
    }
  }

  if (!device || !devices) return <Fragment />;

  const con = get(device, `${type}.${field}`);

  return (
    <Container fluid>
      {con === "HANGUP" && (
        <Message info>
          <Header as='h4'>
            This device currently hangs up
            {/* <span style={{ marginRight: "20px" }} />
            <Button
              size='mini'
              inverted
              primary
              onClick={() => create(type, field)}
            >
              Connect to new device..
            </Button> */}
          </Header>
        </Message>
      )}
      {/* {con !== "HANGUP" && (
        <Button
          size='mini'
          inverted
          primary
          onClick={() => create(type, field)}
        >
          Connect to new device..
        </Button>
      )} */}
      <Table celled padded stackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1} singleLine></Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              Device Type
            </Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              Name
            </Table.HeaderCell>
            <Table.HeaderCell width={2} singleLine>
              Extension
            </Table.HeaderCell>
            <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {devices
          .filter((d:Device)=> d.id !== device.id)
          .map((d: Device) => (
            <Table.Row key={`tr-${d.id}`}>
              <Table.Cell singleLine>
                {d.id === con ? (
                  <Label color='blue' ribbon>
                    Selected
                  </Label>
                ) : (
                  ""
                )}
              </Table.Cell>
              <Table.Cell singleLine>
                <Icon
                  size='large'
                  color={getWidget(d.type).color}
                  name={getWidget(d.type).icon}
                />
                {getWidget(d.type).name}
              </Table.Cell>
              <Table.Cell singleLine>
                <Label as='a' onClick={() => select(d.id)}>
                  {d.name}
                </Label>
              </Table.Cell>

              <Table.Cell singleLine>{d.extension}</Table.Cell>
              <Table.Cell singleLine>
                {d.id === con ? (
                  <Button size='tiny' color='red' onClick={() => disconnect()}>
                    Disconnect
                  </Button>
                ) : (
                  <Button size='tiny' color='blue' onClick={() => connect(d)}>
                    Connect
                  </Button>
                )}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Container>
  );
};

export default ConnectTo;
